import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/policy.css";

const Advertise = () => {
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* Policy starts here */}
			<section className="policy">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="content-wrapper">
								<div className="heading-wrapper">
									<h2>Advertise With us</h2>
									<h6>BE PART OF THE CHANGE</h6>
								</div>
								<div className="para-wrapper">
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Turpis egestas sed tempus urna et pharetra. Faucibus
										purus in massa tempor nec feugiat. Aliquet bibendum enim
										facilisis gravida neque convallis. Vel quam elementum
										pulvinar etiam non quam. Placerat vestibulum lectus mauris
										ultrices eros in. Viverra suspendisse potenti nullam ac
										tortor vitae purus faucibus ornare. Eget est lorem ipsum
										dolor. Aliquam sem et tortor consequat id porta nibh
										venenatis. Ultrices eros in cursus turpis massa tincidunt
										dui ut ornare. Cursus risus at ultrices mi tempus imperdiet.
										Lacus vel facilisis volutpat est. Viverra maecenas accumsan
										lacus vel facilisis. Commodo elit at imperdiet dui accumsan.
									</p>
									<p>
										Non odio euismod lacinia at quis risus sed. Purus ut
										faucibus pulvinar elementum integer enim. Egestas diam in
										arcu cursus euismod quis viverra nibh. Phasellus faucibus
										scelerisque eleifend donec pretium vulputate sapien nec.
										Fames ac turpis egestas maecenas pharetra convallis posuere
										morbi. Ipsum nunc aliquet bibendum enim facilisis gravida
										neque convallis. Lectus proin nibh nisl condimentum id
										venenatis a. Elit scelerisque mauris pellentesque pulvinar
										pellentesque habitant morbi tristique senectus. Dui ut
										ornare lectus sit amet est placerat in egestas. Aliquam
										etiam erat velit scelerisque. Senectus et netus et malesuada
										fames. Libero justo laoreet sit amet cursus. Imperdiet proin
										fermentum leo vel. At tempor commodo ullamcorper a.
										Facilisis magna etiam tempor orci eu lobortis elementum.
										Quam lacus suspendisse faucibus interdum. Dolor morbi non
										arcu risus quis varius quam quisque id. Egestas fringilla
										phasellus faucibus scelerisque eleifend donec.
									</p>
									<p>
										Dignissim enim sit amet venenatis urna. Molestie nunc non
										blandit massa enim nec dui. Risus viverra adipiscing at in
										tellus integer feugiat scelerisque. Arcu vitae elementum
										curabitur vitae nunc sed. Eleifend mi in nulla posuere
										sollicitudin aliquam ultrices sagittis. Enim neque volutpat
										ac tincidunt vitae semper quis. Amet risus nullam eget felis
										eget nunc lobortis mattis aliquam. Nibh nisl condimentum id
										venenatis a condimentum vitae. In hendrerit gravida rutrum
										quisque non tellus orci. Tristique senectus et netus et
										malesuada fames ac turpis
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Policy ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Advertise;
